const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    branch_id: "",
    zone_name: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "zone_masters",
    schema: schema,
    include: [
      {
        model: "branch_masters",
        as: "branch",
      },
    ],
  };

  const navigatePage = { back: "/zone-list" };

  const headerName = "Zone";

  const validationType = "ZoneCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "zone_masters",
    schema: schema,
    include: [
      {
        model: "branch_masters",
        as: "branch",
      },
    ],
    // relations: [
    //   {
    //     module: "user_masters",
    //     moduleAs: "createdBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    //   {
    //     module: "user_masters",
    //     moduleAs: "updatedBy",
    //   },
    // ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Zone Name", value: "zone_name" },
    { label: "Branch Name", value: "branch.branch_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/zone-create",
    edit: "/zone-create",
    view: "/zone-view",
  };

  const searchfields = ["zone_name", "branch.branch_name"];

  const headerName = "Zone";
  const endpoint = "/getRecords";
  const exportFileName = "ZoneData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "zone_masters",
  schema: schema,
  include: [{ module: "branch_masters", moduleAs: "branch" }],
  pagination: { page: 1, pageSize: 10000 },
};
